<ng-container *ngIf="dataset[row][colData.Name + '_BinActive'] === 'Y'">
  <nz-input-group nzSearch [nzAddOnAfter]="suffixButton">
    <nz-input-number *ngIf="dataset[row][colData.Name] !== undefined" nzMin="0" [disabled]="GetDisabledValue()"
    [name]="colData.Name" [(ngModel)]="dataset[row][colData.Name]" [ngModelOptions]="{ updateOn: 'blur'}"
    (ngModelChange)="valueChanged($event);"></nz-input-number>
  </nz-input-group>
  <ng-template #suffixButton>
    <button nz-button nzType="primary" nzSearch (click)="openBinLocationDialog()">
      <i nz-icon nzType="unordered-list" nzTheme="outline"></i>
    </button>
  </ng-template>
</ng-container>
<ng-container *ngIf="dataset[row][colData.Name + '_BinActive'] !== 'Y'">
  <nz-input-number *ngIf="dataset[row][colData.Name] !== undefined" nzMin="0" [disabled]="GetDisabledValue()"
    [name]="colData.Name" [(ngModel)]="dataset[row][colData.Name]" [ngModelOptions]="{ updateOn: 'blur'}"
    (ngModelChange)="valueChanged($event);"></nz-input-number>
</ng-container>
<nz-drawer [nzVisible]="binLocationDrawer" (nzOnClose)="binLocationDrawer = false;" nzWrapClassName="drawer-size-2x" [nzTitle]="'Select bin locations' | locale">
  <nz-table #table *ngIf="binLocationDrawerOpened" [nzData]="binLocationData">
    <thead>
      <tr>
        <th>
          {{'Bin Location' | locale}}
        </th>
        <th *ngIf="dataset[this.row].ManBtchNum === 'Y'">
          {{'Batch Number' | locale}}
        </th>
        <th>
          {{'In Stock' | locale}}
        </th>
        <th>
          {{'Quantity' | locale}}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let bin of table.data">
        <td>
          {{bin.BinCode}}
        </td>
        <td *ngIf="dataset[this.row].ManBtchNum === 'Y'">
          {{bin.DistNumber}}
        </td>
        <td>
          {{bin.OnHandQty}}
        </td>
        <td>
          <nz-input-number [(ngModel)]="bin.SelectedQuantity" [ngModelOptions]="{ updateOn: 'blur'}" (ngModelChange)="binQuantitySelected(bin);"></nz-input-number>
        </td>
      </tr>
    </tbody>
  </nz-table>
</nz-drawer>
